<template>
  <v-progress-linear
    :class="progressBarClass"
    :value="value"
    height="20"
    :color="color"
  >
    <template v-slot="{ value }">
      <strong>{{ Math.ceil(value) }}%</strong>
    </template>
  </v-progress-linear>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';

export default {
  name: 'TablePercentageBar',
  mixins: [ResponsiveSizeHelperMixin],
  props: {
    value: {
      required: false,
      default: '0',
    },
    color: {
      type: String,
      required: false,
      default: 'error',
    },
  },
  computed: {
    progressBarClass() {
      return this.$vuetify.breakpoint.width <= this.dataTableMobileBreakpoint
        ? 'progress-linear-mobile'
        : '';
    },
  },
};
</script>

<style>
.progress-linear-mobile {
  width: 120px !important;
}
</style>
